<template>
  <q-page padding>
    <div class="row col-12">
      <p class="text-h6 text-brand-5 text-weight-bold">
        Carga de usuários por planilha
        <q-icon
          style="cursor: pointer"
          name="info"
          @click="activeSlide = !activeSlide"
        />
      </p>
    </div>

    <infot-upload
      :activeSlide="activeSlide"
      :infos="infos"
      link="https://multpex-docs.s3.us-east-1.amazonaws.com/templates/controle-funcao/usuarios_r3.xlsx"
    />

    <div class="row items-center q-mt-md">
      <div class="col-2">
        <q-file label="Selecione o Template" outlined dense v-model="file">
          <template v-slot:prepend>
            <q-icon name="attach_file" />
          </template>
        </q-file>
      </div>

      <div class="col-2">
        <q-btn
          color="positive"
          icon="add"
          no-caps
          class="q-ml-sm"
          label="Enviar Template"
          @click="enviarTemplate"
        />
      </div>
    </div>
  </q-page>
</template>

<script>
import { ref } from "@vue/reactivity";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import InfotUpload from "../../compras/components/InfotUpload.vue";
export default {
  components: { InfotUpload },
  setup() {
    const activeSlide = ref(false);
    const quasar = useQuasar();
    const store = useStore();
    const file = ref("");

    const infos = ref([
      {
        name: "Não altere a ordem das colunas nem o texto, isso trará problema na importação",
        icon: "do_not_disturb",
      },
      {
        name: "Apague as informações da linha 2 e preencha com seus valores reais",
        icon: "delete",
      },
      {
        name: "O EMAIL não é atualizado por planilha, ele é somente criado em uma primeira execução",
        icon: "view_column",
      },
      {
        name: "O CENTRO DE CUSTO não é atualizado por esta planilha, ele é somente criado em uma primeira execução.",
        icon: "do_not_disturb",
      },
      {
        name: "Se houver erro de digitação da coluna B (ID ou username) outro usuário será criado, por exemplo, se for informado inicialmente o ID 1234 e posteriormente o ID 01234, o sistema criará outro usuário",
        icon: "event",
      },
      {
        name: "Se houver erro de digitação na coluna G (código centro de custo), o sistema criará um novo centro de custo e associará ao colaborador",
        icon: "event",
      },
      {
        name: "Se houver erro de digitação na coluna F (função ou ghe), o sistema criará outra função e associará ao colaborador",
        icon: "event",
      },
      {
        name: "O processamento é feito em segundo plano, e pode levar até 30 minutos, você receberá no seu email o status da importação",
        icon: "event",
      },
    ]);

    const enviarTemplate = async () => {
      if (file.value == "" || file.value.name.indexOf("xlsx") == -1) {
        quasar.notify({
          message: "O tipo do arquivo não e aceito, ou o campo esta vazio",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }

      try {
        var reader = new FileReader();
        reader.readAsDataURL(file.value);
        reader.onload = async function () {
          await store.dispatch("user/criarUsuarioTemplate", {
            planilha: reader.result,
            vendor: store.state.org.unidadeData.id,
          });
        };

        quasar.notify({
          message: "Usuario criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        file.value = "";
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro a o crair Usuario",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        file.value = "";
      }
    };

    return {
      enviarTemplate,
      file,
      activeSlide,
      infos,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
</style>
